import { CommonColors } from "../../../types/colors";

export enum MaterialCardColorScheme {
  Wood = "wood",
  Stone = "stone",
  Glass = "glass",
  Materia = "materia",
  Metal = "metal",
  Primary = "primary",
}

export type MaterialCardDescriptionColors =
  | CommonColors.Light
  | CommonColors.Dark
  | CommonColors.Primary;
